import { useMemo } from 'react';
import { mediaManagerErrorScreenPageview, mediaManagerTryAgainClick } from '@wix/bi-logger-media-data/v2';

import { SettingsLayout } from '../../../constants/Layout';
import { Source } from '../../../constants/Source';
import { bi } from '../../../services/loggers/bi';
import { BIPageName } from '../../../constants/Bi';

export const useTrackErrorStateAnalytics = () =>
  useMemo(
    () => ({
      trackTryAgainButtonClick: (tabName: Source, layout: SettingsLayout) =>
        bi.logger().report(mediaManagerTryAgainClick({ tabName, layout, pageName: BIPageName.MediaManager })),
      trackErrorScreenRendered: (
        tabName: Source,
        layout: SettingsLayout,
        errorReason: string,
        errorStateType: string,
      ) =>
        bi.logger().report(
          mediaManagerErrorScreenPageview({
            errorReason,
            tabName,
            layout,
            errorStateType,
          }),
        ),
    }),
    [],
  );
